import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Modal,
  Image
} from '@lockerpm/design';

import images from "../../assets/images";

import global from "../../config/global";
import common from "../../utils/common";
import storeActions from "../../store/actions";

const PlanNoticeModal = () => {
  const { t } = useTranslation();

  const planNoticeVisible = useSelector((state) => state.payment.planNoticeVisible)
  const onCancel = () => {
    global.store.dispatch(storeActions.updatePlanNoticeVisible(false));
  }

  return (
    <Modal
      open={planNoticeVisible}
      onCancel={() => onCancel()}
      width={640}
      footer={false}
      closeIcon={<></>}
    >
      <div
        className="cursor-pointer"
        onClick={() => {
          common.clickBuyPremium();
          onCancel();
        }}
      >
        <Image
          src={images.PlanNoticeImg}
          preview={false}
        />
      </div>
    </Modal>
  );
}

export default PlanNoticeModal;